import React from 'react';
import Overlay from '../../partials/white_overlay';

const Registration = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Player Registration</h2>
                <p>Teams may carry up to 6 players on their roster (5-6 players recommended). Each team must submit proof of age for each player (such as copy of birth certificate, verified player pass, driver’s license, etc.). Any team or player determined by the event director to have falsified age will be dismissed from the tournament and will not be eligible for a refund.</p>
                <p>A player may play for one team only during an event. Dual rostering for a single event is not allowed. A player can play for multiple teams during the tour season but not during the same event.</p>
                <p>AGE DIVISION BIRTH DATES: We follow US Youth Soccer’s policy of using calendar birth years for the player’s playing age for our events. The age division of a team in the event will be based on the birth year of the oldest player on the team’s roster. Also note that a player may play in a division older than his/her age, but not in one that is younger. In FYSA sanctioned events, “playing up” is limited to the current FYSA guidelines. In events that are sanctioned by Challenge Sports only, “playing up” is left to the discretion of the coach and parents.</p>
            </div>
        </div>
    );
}

export default Registration;



// WEBPACK FOOTER //
// ./src/components/rules/partials/registration.js